import { render } from "./ShareFriends.vue?vue&type=template&id=13a6d729"
import script from "./ShareFriends.vue?vue&type=script&lang=js"
export * from "./ShareFriends.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__